module.exports = __webpack_public_path__ + "media/images/emblems/Eschlikon(Turgovio)-Blazono-489c592a4db0481a1e4350623731764c.png";